import { define } from 'wicked-elements'
import bus from '../bus'

define('[data-component~="grid-filter"]', {
  init () {
    this.key = this.element.getAttribute('data-key')
    this.$grid = document.querySelector('[data-component="grid"]')
    this.$items = [...this.element.children]
    this.setFilter = this.setFilter.bind(this)
    this.handleSetFilter = this.handleSetFilter.bind(this)
    this.filter = null
  },
  connected () {
    this.setClasses()
    this.$items.forEach($item => {
      $item.addEventListener('click', this.setFilter)
    })
    bus.on('filter:set', this.handleSetFilter)
  },
  disconnected () {
    this.$items.forEach($item => {
      $item.removeEventListener('click', this.setFilter)
    })
    bus.removeListener('filter:set', this.handleSetFilter)
  },
  setFilter (e) {
    this.filter = e.target.getAttribute('data-filter')
    bus.emit('filter:set', {
      key: this.key,
      value: this.filter
    })
  },
  setClasses () {
    this.$items.forEach($item => {
      $item.classList.replace('text-black', 'text-accent')
      if ($item.getAttribute('data-filter') == this.filter) {
        $item.classList.replace('text-accent', 'text-black')
      }
    })
    this.$grid.setAttribute('has-filter', this.filter)
  },
  handleSetFilter ({ key, value }) {
    if (key !== this.key) {
      this.$items.forEach($item => {
        $item.classList.replace('text-black', 'text-accent')
        if (!$item.getAttribute('data-filter')) {
          $item.classList.replace('text-accent', 'text-black')
        }
      })
    } else {
      this.filter = value === "" ? null : value
      this.setClasses()
    }
  }
})